module.exports = __webpack_public_path__ + "img/main_circle_mask02.b22a08df.svg";